import { useAppSelector } from 'store/hooks';
import { selectRestreamerStatus } from 'features/restreamer/restreamerSlice';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';

export const useRestreamer = () => {
  const status = useAppSelector(selectRestreamerStatus);

  const isFeatureEnabled = useFeatureFlag('restreaming');

  const { hasPermissions } = usePermissions();
  const canStream = hasPermissions(PermissionTypes.restreaming);

  const isFeatureAvailable = isFeatureEnabled && canStream;

  return {
    isFeatureAvailable,
    status,
    active: status === 'started',
    canStream,
  };
};
